import { HttpClient } from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import { blockUi } from "@bndes/bndes-ux4/bndes-angular-utils";
import { AnalisesCondicionadas } from '../model/AnalisesCondicionadas';

@Injectable({
  providedIn: 'root'
})
export class AnalisesCondicionadasService {

  private BASE_URL = './rest/condicionantes';

  constructor(private http: HttpClient) {
  }

  obterAnalisesCondicionadas(idPac: number): Observable<AnalisesCondicionadas[]> {
    return this.http.get<AnalisesCondicionadas[]>(`${this.BASE_URL}/busca-analises/${idPac}`, blockUi()).pipe();
  }


}
